// src/core/config/env.ts

const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname.endsWith(".lvh.me");

export const ENV = isLocal
  ? {
      // ===============================
      // API BASE
      // ===============================

      API_BASE_URL: "https://api.auth.lvh.me:2000/api",
      STORAGE_BASE_URL: "https://api.auth.lvh.me:2000",

      // ===============================
      // NOTIFY API
      // ===============================

      NOTIFY_API_BASE_URL: "https://api.notify.lvh.me:2008/api",

      // ===============================
      // VAPID (Web Push)
      // ===============================

      VAPID_PUBLIC_KEY: "BKCttjJi15e8NZQg1cUcaG-alNNqEYpkUUE3amrgCDmJFTEIE0_a-NkcRF3ZLdzmLVtIS9M6Q7DmC84ZuUOYQVo",

      // ===============================
      // AUTH APPLICATION
      // ===============================

      AUTH_APP_URL: "https://auth.lvh.me:2001",
      MYACCOUNT_CALLBACK_PATH: "/auth/callback",

      // ===============================
      // AUTH API
      // ===============================

      API_STATUS: "/status",
      API_REGISTER: "/auth/register",
      API_LOGIN: "/auth/login",
      API_REFRESH: "/auth/refresh",
      API_ME: "/auth/me",
      API_LOGOUT: "/auth/logout",
      API_FORGOT_PASSWORD: "/auth/forgot-password",
      API_VERIFY_RESET_CODE: "/auth/verify-reset-code",
      API_RESET_PASSWORD: "/auth/reset-password",

      // ===============================
      // MY ACCOUNT API
      // ===============================

      API_PROFILE: "/user/profile",
      API_EMAILS: "/user/emails",
      API_PHONES: "/user/phones",
      API_AVATAR: "/user/profile/avatar",
      API_PREFERENCES: "/user/preferences",
      API_CHANGE_PASSWORD_INIT: "/user/change-password/init",
      API_CHANGE_PASSWORD_CONFIRM: "/user/change-password/confirm",
      API_SESSIONS: "/user/security/sessions",
      API_DEVICES: "/user/security/devices",

      // ===============================
      // IAM
      // ===============================

      API_IAM_ACCESS: "/iam/access",
      API_IAM_CAN: "/iam/can",
    }
  : {
      // ===============================
      // PRODUCTION
      // ===============================

      API_BASE_URL: "https://api.auth.hubvex.com/api",
      STORAGE_BASE_URL: "https://api.auth.hubvex.com",

      // ===============================
      // NOTIFY API (PRODUCTION)
      // ===============================

      NOTIFY_API_BASE_URL: "https://api.notify.hubvex.com/api",

      // ===============================
      // VAPID (Web Push) PRODUCTION
      // ===============================

      VAPID_PUBLIC_KEY: "BKCttjJi15e8NZQg1cUcaG-alNNqEYpkUUE3amrgCDmJFTEIE0_a-NkcRF3ZLdzmLVtIS9M6Q7DmC84ZuUOYQVo",

      // ===============================
      // AUTH APPLICATION
      // ===============================

      AUTH_APP_URL: "https://auth.hubvex.com",
      MYACCOUNT_CALLBACK_PATH: "/auth/callback",

      // ===============================
      // AUTH API
      // ===============================

      API_STATUS: "/status",
      API_REGISTER: "/auth/register",
      API_LOGIN: "/auth/login",
      API_REFRESH: "/auth/refresh",
      API_ME: "/auth/me",
      API_LOGOUT: "/auth/logout",
      API_FORGOT_PASSWORD: "/auth/forgot-password",
      API_VERIFY_RESET_CODE: "/auth/verify-reset-code",
      API_RESET_PASSWORD: "/auth/reset-password",

      // ===============================
      // MY ACCOUNT API
      // ===============================

      API_PROFILE: "/user/profile",
      API_EMAILS: "/user/emails",
      API_PHONES: "/user/phones",
      API_AVATAR: "/user/profile/avatar",
      API_PREFERENCES: "/user/preferences",
      API_CHANGE_PASSWORD_INIT: "/user/change-password/init",
      API_CHANGE_PASSWORD_CONFIRM: "/user/change-password/confirm",
      API_SESSIONS: "/user/security/sessions",
      API_DEVICES: "/user/security/devices",

      // ===============================
      // IAM
      // ===============================

      API_IAM_ACCESS: "/iam/access",
      API_IAM_CAN: "/iam/can",
    };